import React, { useState } from 'react';
import {
    Button,
    Container,
    FormControl,
    InputLabel,
    Box,
    Checkbox,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    MenuItem,
    Select,
    Tooltip,
    AppBar,
    Toolbar,
    Typography,
} from '@mui/material';
import LoadingBar from 'react-top-loading-bar';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import { useParams } from "react-router-dom";
import base64 from "base64-js";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});


const ManageUser = () => {
    const [canAdd, setCanAdd] = useState(true);
    const [canEdit, setCanEdit] = useState(true);
    const [canDelete, setCanDelete] = useState(true);
    const [canRead, setCanRead] = useState(true);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [snackbarMessage, setSnackbarMessage] = useState('');
    const [organizationName, setOrganizationName] = useState('');
    const [branchName, setBranchName] = useState('');
    const [userRole, setUserRole] = useState('');
    const [moduleName, setModuleName] = useState('');
    const [loadingBarProgress, setLoadingBarProgress] = useState(0);
    const [showTable, setShowTable] = useState(false);
    const [selectAll, setSelectAll] = useState(false);
    const [permissions, setPermissions] = useState([
        { moduleId: 1, moduleName: 'Admission', formName: 'Admission Form', read: false, write: false, modify: false, delete: false },
        { moduleId: 2, moduleName: 'Admission', formName: 'Exam Registration', read: false, write: false, modify: false, delete: false },
        { moduleId: 3, moduleName: 'Feedback', formName: 'Feedback Form', read: false, write: false, modify: false, delete: false },
        { moduleId: 4, moduleName: 'Leave', formName: 'Leave Request', read: false, write: false, modify: false, delete: false },
    ]);

    const decodeFormId = (encodedFormId) => {
        if (!encodedFormId || typeof encodedFormId !== "string") {
            console.error("encodedFormId is missing or invalid:", encodedFormId);
            return null;
        }
        try {
            const paddedEncodedFormId = encodedFormId.padEnd(Math.ceil(encodedFormId.length / 4) * 4, "=");
            const bytes = base64.toByteArray(paddedEncodedFormId);
            return new TextDecoder().decode(bytes);
        } catch (error) {
            console.error("Error decoding formId:", error);
            return null;
        }
    };

    const { encodedFormId } = useParams();
    const formId = decodeFormId(encodedFormId);

    const Authorizer = async () => {
        try {
            const apiUrl = process.env.REACT_APP_BASE_URL;
            const token = sessionStorage.getItem("token");
            const response = await fetch(`${apiUrl}/CPanel/Module_Authorizer`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: token,
                },
                body: JSON.stringify({ formId, }), // replace with actual formId if hardcoded
            });

            const result = await response.json();
            const data = result[0];

            // setAuthorization(data);
            setCanEdit(data?.uModify === 1);
            setCanAdd(data?.uWrite === 1);
            setCanDelete(data?.uDelete === 1);
            setCanRead(data?.uRead === 1);
        } catch (error) {
            console.error("Authorization check failed:", error);
        }
    };

    // Static data for dropdowns
    const organizationOptions = [
        { value: 'org1', label: 'Organization 1' },
        { value: 'org2', label: 'Organization 2' },
    ];

    const branchOptions = [
        { value: 'branch1', label: 'Branch 1' },
        { value: 'branch2', label: 'Branch 2' },
    ];

    const userRoleOptions = [
        { value: 'admin', label: 'Admin' },
        { value: 'staff', label: 'Staff' },
        { value: 'student', label: 'Student' },
    ];

    const moduleOptions = [
        { value: 'admission', label: 'Admission' },
        { value: 'feedback', label: 'Feedback' },
        { value: 'leave', label: 'Leave' },
        { value: 'exam', label: 'Exam' },
    ];

    const handleSearch = () => {
        if (!organizationName || !branchName || !userRole || !moduleName) {
            alert('Please select all fields!');
            return;
        }
        setShowTable(true);
    };

    const handleSelectAll = (e) => {
        const isChecked = e.target.checked;
        setSelectAll(isChecked);
        setPermissions(
            permissions.map((permission) => ({
                ...permission,
                read: isChecked,
                write: isChecked,
                modify: isChecked,
                delete: isChecked,
            }))
        );
    };

    const handlePermissionChange = (index, field) => {
        const updatedPermissions = [...permissions];
        updatedPermissions[index][field] = !updatedPermissions[index][field];
        setPermissions(updatedPermissions);
    };

    const handleSave = () => {
        setLoadingBarProgress(30);
        setTimeout(() => {
            setLoadingBarProgress(100);
            setSnackbarMessage('Permissions saved successfully!');
            setOpenSnackbar(true);
        }, 1000);
    };

    const handleCancel = () => {
        setShowTable(false);
        setPermissions(
            permissions.map((permission) => ({
                ...permission,
                read: false,
                write: false,
                modify: false,
                delete: false,
            }))
        );
    };

    return (
    <> {!canRead ?(<h2 style={{color:'red'}}>You are not Authorized to View this Page!</h2>):
        ( <Container>
            <AppBar position="static" style={{ backgroundColor: "#0B1F3D" }}>
                <Toolbar>
                    <Typography variant="h4" component="div" style={{ fontWeight: 'bold' }}>
                        Manage User Permissions
                    </Typography>
                </Toolbar>
            </AppBar>
            <Paper elevation={3} style={{ padding: 16, width: '100%', margin: 'auto', marginTop: 6 }}>
                <LoadingBar progress={loadingBarProgress} color="rgb(152, 106, 182)" height={5} />
                <Box sx={{ display: 'flex', gap: 2, mb: 3 }}>
                    <FormControl fullWidth>
                        <InputLabel>Organization Name</InputLabel>
                        <Select
                            value={organizationName}
                            label="Organization Name"
                            onChange={(e) => setOrganizationName(e.target.value)}
                        >
                            {organizationOptions.map((org) => (
                                <MenuItem key={org.value} value={org.value}>
                                    {org.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel>Branch Name</InputLabel>
                        <Select
                            value={branchName}
                            label="Branch Name"
                            onChange={(e) => setBranchName(e.target.value)}
                        >
                            {branchOptions.map((branch) => (
                                <MenuItem key={branch.value} value={branch.value}>
                                    {branch.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel>User Role</InputLabel>
                        <Select
                            value={userRole}
                            label="User Role"
                            onChange={(e) => setUserRole(e.target.value)}
                        >
                            {userRoleOptions.map((role) => (
                                <MenuItem key={role.value} value={role.value}>
                                    {role.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                    <FormControl fullWidth>
                        <InputLabel>Module Name</InputLabel>
                        <Select
                            value={moduleName}
                            label="Module Name"
                            onChange={(e) => setModuleName(e.target.value)}
                        >
                            {moduleOptions.map((module) => (
                                <MenuItem key={module.value} value={module.value}>
                                    {module.label}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Box>
                <Tooltip title={!canEdit && "You are not Authorized to Edit"} arrow><span>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleSearch}
                        sx={{ mb: 3 }}
                        disabled={!canEdit}
                    >
                        Search
                    </Button></span></Tooltip>

                    {showTable && (
                        <>
                            <TableContainer component={Paper} sx={{ mb: 3 }}>
                                <Table>
                                    <TableHead>
                                        <TableRow>
                                            <TableCell padding="checkbox">
                                                <Checkbox
                                                    checked={selectAll}
                                                    onChange={handleSelectAll}
                                                />
                                            </TableCell>
                                            <TableCell>Module Name</TableCell>
                                            <TableCell>Form Name</TableCell>
                                            <TableCell>
                                                <Checkbox
                                                    checked={permissions.every((p) => p.read)}
                                                    onChange={(e) =>
                                                        setPermissions(
                                                            permissions.map((permission) => ({
                                                                ...permission,
                                                                read: e.target.checked,
                                                            }))
                                                        )
                                                    }
                                                />
                                                Read
                                            </TableCell>
                                            <TableCell>
                                                <Checkbox
                                                    checked={permissions.every((p) => p.write)}
                                                    onChange={(e) =>
                                                        setPermissions(
                                                            permissions.map((permission) => ({
                                                                ...permission,
                                                                write: e.target.checked,
                                                            }))
                                                        )
                                                    }
                                                />
                                                Write
                                            </TableCell>
                                            <TableCell>
                                                <Checkbox
                                                    checked={permissions.every((p) => p.modify)}
                                                    onChange={(e) =>
                                                        setPermissions(
                                                            permissions.map((permission) => ({
                                                                ...permission,
                                                                modify: e.target.checked,
                                                            }))
                                                        )
                                                    }
                                                />
                                                Modify
                                            </TableCell>
                                            <TableCell>
                                                <Checkbox
                                                    checked={permissions.every((p) => p.delete)}
                                                    onChange={(e) =>
                                                        setPermissions(
                                                            permissions.map((permission) => ({
                                                                ...permission,
                                                                delete: e.target.checked,
                                                            }))
                                                        )
                                                    }
                                                />
                                                Delete
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {permissions.map((permission, index) => (
                                            <TableRow key={permission.moduleId}>
                                                <TableCell padding="checkbox">
                                                    <Checkbox
                                                        checked={permission.read && permission.write && permission.modify && permission.delete}
                                                        onChange={(e) => {
                                                            const isChecked = e.target.checked;
                                                            const updatedPermissions = [...permissions];
                                                            updatedPermissions[index] = {
                                                                ...updatedPermissions[index],
                                                                read: isChecked,
                                                                write: isChecked,
                                                                modify: isChecked,
                                                                delete: isChecked,
                                                            };
                                                            setPermissions(updatedPermissions);
                                                        }}
                                                    />
                                                </TableCell>
                                                <TableCell>{permission.moduleName}</TableCell>
                                                <TableCell>{permission.formName}</TableCell>
                                                <TableCell>
                                                    <Checkbox
                                                        checked={permission.read}
                                                        onChange={() => handlePermissionChange(index, 'read')}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <Checkbox
                                                        checked={permission.write}
                                                        onChange={() => handlePermissionChange(index, 'write')}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <Checkbox
                                                        checked={permission.modify}
                                                        onChange={() => handlePermissionChange(index, 'modify')}
                                                    />
                                                </TableCell>
                                                <TableCell>
                                                    <Checkbox
                                                        checked={permission.delete}
                                                        onChange={() => handlePermissionChange(index, 'delete')}
                                                    />
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                            <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 2 }}>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={handleSave}
                                >
                                    Save
                                </Button>
                                <Button
                                    variant="contained"
                                    color="error"
                                    onClick={handleCancel}
                                >
                                    Cancel
                                </Button>
                            </Box>
                        </>
                    )}
                </Paper>

                    <Snackbar
                        open={openSnackbar}
                        autoHideDuration={4000}
                        onClose={() => setOpenSnackbar(false)}
                        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
                    >
                        <Alert onClose={() => setOpenSnackbar(false)} severity="success" sx={{ width: '100%' }}>
                            {snackbarMessage}
                        </Alert>
                    </Snackbar>


                </Container>)}
                </>
                );
};

                export default ManageUser;
